import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  // Full-screen root — matches --nav-bg-page: #F5F9FF
  screenRoot: {
    flex: 1,
    backgroundColor: "#F5F9FF",
  },
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 16,
  },
  errorText: {
    fontSize: 14,
    color: "#C12C01",
    textAlign: "center",
  },
  // Page header — white surface, bottom border separating from body
  header: {
    flexDirection: "row",
    alignItems: "flex-start",
    paddingHorizontal: 36,
    paddingTop: 20,
    paddingBottom: 16,
    backgroundColor: "#FFFFFF",
    borderBottomWidth: 1,
    borderBottomColor: "#EBEBEB",
  },
  headerContent: {
    flex: 1,
  },
  // Breadcrumb — matches .page-header .breadcrumb
  breadcrumb: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    marginBottom: 4,
  },
  breadcrumbLink: {
    fontSize: 12,
    color: "#585858",
    fontWeight: "500",
  },
  breadcrumbSep: {
    fontSize: 12,
    color: "#656565",
    opacity: 0.6,
  },
  breadcrumbCurrent: {
    fontSize: 12,
    color: "#3A3A3A",
    fontWeight: "600",
  },
  // Page title — matches .page-header .page-title: 28px bold #2D2D2D
  pageTitle: {
    fontSize: 28,
    fontWeight: "700",
    color: "#2D2D2D",
    lineHeight: 34,
  },
  // Page subtitle — matches .page-header .page-subtitle: 13px #656565
  pageSubtitle: {
    fontSize: 13,
    color: "#656565",
    marginTop: 2,
    fontWeight: "400",
  },
  // Tabs row — matches .tabs: border-bottom 2px #D7E5F8, white bg, px 20
  tabNavigation: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    borderBottomWidth: 2,
    borderBottomColor: "#D7E5F8",
    paddingHorizontal: 20,
    gap: 4,
  },
  // Tab button — matches .tab: px 16, py 12, negative margin to overlap border
  tabButton: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderBottomWidth: 2,
    borderBottomColor: "transparent",
    marginBottom: -2,
  },
  // Active tab — border-bottom color #005CBC (#nav-blue-700)
  tabButtonActive: {
    borderBottomColor: "#005CBC",
  },
  // Tab label — matches .tab: 14px 600 #585858
  tabButtonText: {
    fontSize: 14,
    fontWeight: "600",
    color: "#585858",
  },
  // Active tab label — 14px 700 #005CBC
  tabButtonTextActive: {
    color: "#005CBC",
    fontWeight: "700",
  },
  // Scrollable content area
  content: {
    flex: 1,
    backgroundColor: "#F5F9FF",
  },
  // Content padding — matches .screen: padding: 24px 36px
  contentContainer: {
    padding: 24,
    paddingHorizontal: 36,
  },
  tabPane: {
    flexDirection: "column",
  },
  // Config tip — matches .config-tip: bg #F3F7FD, border #DAEEFA (--nav-blue-75), radius 8, gap 10
  configTip: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 10,
    backgroundColor: "#F3F7FD",
    borderWidth: 1,
    borderColor: "#DAEEFA",
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginBottom: 16,
  },
  configTipText: {
    flex: 1,
    fontSize: 13,
    color: "#4B4B4B",
    lineHeight: 19,
  },
  // Read-only banner shown to Sustain Team Members (non-Lead) — matches the
  // amber "read-only" banner pattern used on NotificationsCommsScreen.
  readOnlyBanner: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    backgroundColor: "#FFF4E5",
    borderLeftWidth: 4,
    borderLeftColor: "#FF8C09",
    borderRadius: 6,
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginBottom: 16,
  },
  readOnlyBannerText: {
    flex: 1,
    fontSize: 13,
    color: "#4B4B4B",
    lineHeight: 19,
  },
});

export default styles;
